export const isPastDate = (date: Date): boolean => date < new Date(new Date().toDateString());
